export default "__VITE_ASSET__BeyQ0oQS__"